module.exports = __webpack_public_path__ + "static/media/oracle.079ef52b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/oracle.png
// module id = 163
// module chunks = 0